
import ListComponent from "../../../components/shipping_orders/Index.vue";

export default {
  components: {
    ListComponent,
  },
};
